<p-dialog
  [(visible)]="dialogVisible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{width: '90vw'}"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  header="{{'select.defaultDevice' | transloco}}"
>
  <div class="flex justify-content-between pt-4 pb-3">
    <div class="flex">
      <span class="p-float-label p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            [(ngModel)]="currentFilters.name"
            (keyup.enter)="applyFilters()"
            type="text"
            id="name"
            pInputText
          >
          <label for="name">{{'attribute.name' | transloco}}</label>
      </span>
      <span class="p-float-label p-input-icon-left ml-2">
          <i class="pi pi-search"></i>
          <input
            [(ngModel)]="currentFilters.version"
            (keyup.enter)="applyFilters()"
            type="text"
            id="version"
            pInputText
          >
          <label for="version">{{'attribute.version' | transloco}}</label>
      </span>
      <span class="p-float-label ml-2 w-16rem">
        <p-multiSelect
          [(ngModel)]="currentFilters.defaultDeviceCategoryNames"
          [styleClass]="'w-full'"
          [options]="defaultDeviceCategories"
          [filter]="true"
          optionLabel="value"
          optionValue="value"
          inputId="category"
          display="chip"
          appendTo="body"
        ></p-multiSelect>
        <label>{{'model.category' | transloco}}</label>
      </span>
      <span class="p-float-label ml-2 w-16rem">
        <p-multiSelect
          [(ngModel)]="currentFilters.defaultAssetRepresentationNames"
          [styleClass]="'w-full'"
          [options]="defaultAssetRepresentations"
          [filter]="true"
          optionLabel="value"
          optionValue="value"
          inputId="assetRepresentation"
          display="chip"
          appendTo="body"
        ></p-multiSelect>
        <label>{{'model.assetRepresentation' | transloco}}</label>
      </span>
    </div>
    <div>
      <button
        [label]="'common.search' | transloco"
        (click)="applyFilters()"
        pButton
        icon="pi pi-search"
        iconPos="right"
      ></button>
    </div>
  </div>

  <p-table
    [(selection)]="selectedDefaultDevice"
    [(first)]="first"
    [(rows)]="rows"
    [value]="defaultDevices"
    [totalRecords]="totalDefaultDevices"
    [lazy]="true"
    (onLazyLoad)="onPageChange($event)"
    [paginator]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [autoLayout]="true"
    [sortField]="DEFAULT_SORT_FIELD"
    [sortOrder]="DEFAULT_SORT_ORDER"
    responsiveLayout="stack"
    styleClass="p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="selection-column-width"></th>
        <th pSortableColumn="name">
          {{'attribute.name' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="version">
          {{'attribute.version' | transloco}}
          <p-sortIcon field="version"></p-sortIcon>
        </th>
        <th pSortableColumn="creationDate">
          {{'attribute.creationAt' | transloco}}
          <p-sortIcon field="creationDate"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="defaultDeviceCategory.name">
          {{'model.deviceCategory' | transloco}}
          <p-sortIcon field="defaultDeviceCategory.name"></p-sortIcon>
        </th>
        <th pSortableColumn="defaultAssetRepresentation.name">
          {{'model.assetRepresentation' | transloco}}
          <p-sortIcon field="defaultAssetRepresentation.name"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-defaultDevice>
      <ng-component *ngIf="!hasBeenOpened || loadingDefaultDevices then skeletonRow else dataRow"></ng-component>
      <ng-template #dataRow>
        <tr>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'common.select' | transloco}}</span>
            <p-tableRadioButton [value]="defaultDevice"></p-tableRadioButton>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
            <a [href]="'/hw-catalog/' + defaultDevice.uuid + '/details'" target="_blank">{{defaultDevice.name}}</a>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.version' | transloco}}</span>
            <p class="text-right md:text-left">{{defaultDevice.version}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.creationAt' | transloco}}</span>
            <p class="text-right md:text-left">{{defaultDevice.creationDate | customDate}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
            <p class="text-right md:text-left">{{defaultDevice.description}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'model.deviceCategory' | transloco}}</span>
            <p class="text-right md:text-left">{{defaultDevice.defaultDeviceCategory.name}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'model.assetRepresentation' | transloco}}</span>
            <p class="text-right md:text-left">{{defaultDevice.defaultAssetRepresentation.name}}</p>
          </td>
        </tr>
      </ng-template>
      <ng-template #skeletonRow>
        <tr>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
        </tr>
      </ng-template>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="totalDefaultDevices == 0">
        {{'pagination.empty' | transloco}}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="totalDefaultDevices > 0">
        {{'pagination.showing' | transloco}} {{first + 1}}
        {{'pagination.to' | transloco}} {{(first + rows) >= totalDefaultDevices ? totalDefaultDevices : (first + rows)}}
        {{'pagination.of' | transloco}} {{totalDefaultDevices}}
        {{(totalDefaultDevices > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
      </div>
    </ng-template>
  </p-table>

  <div class="flex justify-content-end py-3">
    <button
      *ngFor="let actionButton of actionButtons"
      [label]="actionButton.label | transloco"
      (click)="actionButton.action(selectedDefaultDevice)"
      [disabled]="!selectedDefaultDevice"
      [icon]="actionButton.icon"
      pButton
      class="mr-2"
      iconPos="right"
    ></button>
  </div>

</p-dialog>
